export default from './Background';



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/components/Background/index.js